import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Dialog, Typography } from '@mui/material';

import { RoundedButton } from '@/components/buttons';
import { DialogActionsContainer, DialogContentContainer, DialogHeader } from '@/components/dialogs';
import { OrdersPaths } from '@/shared/lib/react-router';

import { useReconciliationOrderGuid } from '../../reconciliation-file.store';
import { useIsSkipDialogOpen, useReconciliationBindingActions } from '../reconciliation-binding.store';

export const ReconciliationSkipBindingDialog = () => {
  const { t } = useTranslation('orders-page');
  const navigate = useNavigate();
  const isOpen = useIsSkipDialogOpen();
  const { closeSkipDialog } = useReconciliationBindingActions();
  const orderGuid = useReconciliationOrderGuid();

  const handleProceed = () => {
    closeSkipDialog();
    navigate(OrdersPaths.RECONCILIATION_RESULT.replace(':orderGuid', orderGuid));
  };

  return (
    <Dialog fullWidth maxWidth="xs" open={isOpen} onClose={closeSkipDialog}>
      <DialogHeader
        variant="warning"
        title={t('reconciliation.binding.dialogs.skip-binding.title')}
        onClose={closeSkipDialog}
      />
      <DialogContentContainer>
        <Typography variant="Body/medium" color="neutral.700">
          {t('reconciliation.binding.dialogs.skip-binding.message')}
        </Typography>
      </DialogContentContainer>
      <DialogActionsContainer>
        <RoundedButton variant="outlined" onClick={closeSkipDialog}>
          {t('reconciliation.binding.dialogs.skip-binding.cancel')}
        </RoundedButton>
        <RoundedButton variant="contained" autoFocus onClick={handleProceed}>
          {t('reconciliation.binding.dialogs.skip-binding.continue')}
        </RoundedButton>
      </DialogActionsContainer>
    </Dialog>
  );
};
